// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";
import * as ACTIONS_DEALER_CONFIGURATION from "../DealerConfiguration/state/actionTypes";

// Functions
import { parseAPIEngineDealer, parseAPIListing } from './utils';
import { createAPINetworkInstance } from '../../../common/api';

// Types
import { ActionGetEngineDealerAPI, getEngineDealerAPIError, getEngineDealerAPISuccess, ActionGetLastSyncDateAPI, getLastSyncDateAPIError, getLastSyncDateAPISuccess, ActionSyncEngineDealerAPI,syncEngineDealerAPISuccess, syncEngineDealerAPIError, syncEngineDealerAPI,unsyncEngineDealerAPISuccess, unsyncEngineDealerAPIError, unsyncEngineDealerAPI, ActionGetDealerCountryAPI, getDealerCountryAPISuccess, getDealerCountryAPIError, getCountryStateAPI, getCountryStateAPISuccess, getCountryStateAPIError, ActionGetCountryStateAPI } from './actions';
import { EngineDealer, Listing } from './types';
import { ActionDealerCacheSyncRequest, postDealerCacheSyncError, postDealerCacheSyncSuccess, postListingCacheSyncError, postListingCacheSyncSuccess } from 'features/Dealers/DealerConfiguration/state/actions';

function* getEngineDealer(action: ActionGetEngineDealerAPI) {
    try {
        const { idengine, iddealer } = action
        const { data } = yield call(createAPINetworkInstance().get, `/engine/${idengine}/dealer/${iddealer}`);
        const enginedealeritem: EngineDealer = parseAPIEngineDealer(data);
        yield put(getEngineDealerAPISuccess(enginedealeritem));
    } catch (err) {
        yield put(getEngineDealerAPIError(err));
    }
}

function* getLastSyncDate(action: ActionGetLastSyncDateAPI) {
    try {
        const { iddealer } = action
        const { data } = yield call(createAPINetworkInstance().get, `/dealer/${iddealer}/lastsyncdate`);
        yield put(getLastSyncDateAPISuccess(data));
    } catch (err) {
        yield put(getLastSyncDateAPIError(err));
    }
}

function* postDealerCacheSync(action: ActionGetEngineDealerAPI) {
    try {
        const { listingId } = action as ActionDealerCacheSyncRequest
        const { data } = yield call(createAPINetworkInstance().post, `listing/${listingId}/cachetype/LOCATION`);
        yield put(postDealerCacheSyncSuccess());
    } catch (err) {
        yield put(postDealerCacheSyncError(err));
    }
}

function* postListingCacheSync(action: ActionGetEngineDealerAPI) {
    try {
        const { listingId } = action as ActionDealerCacheSyncRequest
        const { data } = yield call(createAPINetworkInstance().post, `listing/${listingId}/cachetype/LOCATION`);
        yield put(postListingCacheSyncSuccess());
    } catch (err) {
        yield put(postListingCacheSyncError(err));
    }
}


function* syncEngineDealer(action: ActionSyncEngineDealerAPI) {
    try {
        const { idengine, iddealer } = action
        const { data } = yield call(createAPINetworkInstance().post, `/engine/${idengine}/dealer/${iddealer}/sync`);
        const listingitem: Listing = parseAPIListing(data);
        yield put(syncEngineDealerAPISuccess(listingitem));
    } catch (err) {
        yield put(syncEngineDealerAPIError(err));
    }
}

function* unsyncEngineDealer(action: ActionSyncEngineDealerAPI) {
    try {
        const { idengine, iddealer } = action
        const { data } = yield call(createAPINetworkInstance().post, `/engine/${idengine}/dealer/${iddealer}/unsync`);
        const listingitem: Listing = parseAPIListing(data);
        yield put(unsyncEngineDealerAPISuccess(listingitem));
    } catch (err) {
        yield put(unsyncEngineDealerAPIError(err));
    }
}

function* getDealerCountryData(action: ActionGetDealerCountryAPI) {
    try {
        const { iddealer } = action
        const { data } = yield call(createAPINetworkInstance().get, `/dealers/${iddealer}/countrydata`);
        yield put(getDealerCountryAPISuccess(data));
    } catch (err) {
        yield put(getDealerCountryAPIError(err));
    }
}


function* getCountryState(action: ActionGetCountryStateAPI) {
    try {        
        const { data } = yield call(createAPINetworkInstance().get, `/utils/COUNTRY_STATE`);
        yield put(getCountryStateAPISuccess(data));
    } catch (err) {
        yield put(getCountryStateAPIError(err));
    }
}


export default function* enginedealerSagas() {
    yield takeLatest(ACTIONS.GET_ENGINEDATA_API_REQUEST, getEngineDealer);
    yield takeLatest(ACTIONS.GET_LASTSYNCDATE_API_REQUEST, getLastSyncDate);
    yield takeLatest(ACTIONS_DEALER_CONFIGURATION.POST_DEALER_CACHE_SYNC_API_REQUEST, postDealerCacheSync);
    yield takeLatest(ACTIONS_DEALER_CONFIGURATION.POST_LISTING_DEPARTMENT_CACHE_API_REQUEST, postListingCacheSync);
    yield takeLatest(ACTIONS.SYNC_DEALER_API_REQUEST, syncEngineDealer);
    yield takeLatest(ACTIONS.UNSYNC_DEALER_API_REQUEST, unsyncEngineDealer);
    yield takeLatest(ACTIONS.GET_DEALERCOUNTRY_API_REQUEST, getDealerCountryData);
    yield takeLatest(ACTIONS.GET_COUNTRYSTATE_API_REQUEST, getCountryState);
}
